import React from 'react';
import CharacterEmptyState from '../common/CharacterEmptyState';

type AssignmentKindEmptyStateProps = {
  message: string;
};

const AssignmentKindEmptyState: React.FC<AssignmentKindEmptyStateProps> = ({ message }) => (
  <CharacterEmptyState message={message} className="cp-apn-kind-section-empty" />
);

export default AssignmentKindEmptyState;
